import { atom } from 'jotai';
export enum ModalMode {
  Session = 'Session',
  Inactivity = 'Inactivity',
}
interface ModalState {
  open: boolean;
  mode: ModalMode;
}
export const isMoreMenuOpenAtom = atom<boolean>(false);
export const showChangeStatusModalAtom = atom<ModalState>({ open: false, mode: ModalMode.Session });
export const isOnlineAtom = atom<boolean>(true);
